<template>
  <div class='h-subscriber-subTabs'>
    <div class='h-subscriber-subTabs-placeholder'>
    </div>
    <ejs-tab :ref='refName' heightAdjustMode='heightAdjustMode' :showCloseButton='showCloseButton' :cssClass='tabsClass' :width="width">
      <div class="e-tab-header h-subscriber-subTabs-header">
        <div v-for="item of items" :key="item.contentKey">{{item.header}}</div>
      </div>
      <div class="e-content h-subscriber-subTabs-content">
        <slot name="tabsContent"></slot>
      </div>
    </ejs-tab>
  </div>
</template>
<script>
const heightMode = 'Fill';
export default {
  name: 'SubTabs',
  props: [
    'elements',
    'styles'
  ],
  data() {
    return {
      refName: this.elements.refName,
      items: this.elements.items,
      heightAdjustMode: !this.styles.heightMode ? this.styles.heightMode : heightMode,
      height: this.styles.height,
      showCloseButton: this.elements.isClose,
      tabsClass: 'h-subscriber-tabs',
      width: '780px',
      margin: 25

    };
  },
  mounted() {
    // document.getElementById('e-item_0').style = 'margin-left:25px;';
  },
  methods: {
    addTab(itemIndex) {
      this.$refs[`${this.refName}`].hideTab(itemIndex);
    }
  }
};
</script>

<style scoped>

</style>
